import {Component, DoCheck, OnInit} from '@angular/core';
import {Router} from '@angular/router';

@Component({
  selector: 'gryf-footer',
  templateUrl: './footer.component.html'
})
export class FooterComponent implements OnInit, DoCheck {
  offer = false;

  constructor(private router: Router) {
  }

  ngOnInit(): void {
  }

  ngDoCheck(): void {
    this.offer = this.router.url !== '/surface-offer' && !this.router.url.includes('e-offer');
  }
}
